import axios from "axios";
import store from "@/store";

console.log(process.env);

const getBaseUrl = (isTw = false) => {
  if (isTw) {
    if (process.env.NODE_ENV == "production") {
      if (process.env.BUILD_PATH == "uat") {
        return "http://175.97.136.165:13369/lottery";
      } else {
        return "https://lottery-server.omniheroes.tw/lottery";
      }
    } else {
      return "/twProxy";
    }
  }
  if (process.env.NODE_ENV == "production") {
    if (process.env.BUILD_PATH == "uat") {
      return "/community";
    } else {
      return "https://community.omnidreamgames.com/community";
    }
  } else if (process.env.NODE_ENV == "development") {
    return "/proxy";
  }
};

let baseUrl = getBaseUrl();
let twBaseURL = getBaseUrl(true);

// 创建实例时配置默认值
const instance = axios.create({
  baseURL: baseUrl,
  timeout: 30000,
});

// 创建港澳台幸运抽奖请求实例
const twInstance = axios.create({
  baseURL: twBaseURL,
  timeout: 30000,
});

const requestInterceptor = (config: any) => {
  if (config.data) {
    config.data.token = store.getState().user.userInfo?.token || "";
  }
  if (config.params) {
    config.params.token = store.getState().user.userInfo?.token || "";
  }
  return config;
};

const responseInterceptor = (response: any) => {
  const data = response.data || {};
  if (data.code && data.message) {
    window.alert(
      JSON.stringify({
        action: "toast",
        toastMsg: data.message,
      })
    );
    return Promise.reject(data.message);
  }
  return data;
};

const errorHandler = (error: any) => {
  return Promise.reject(error);
};

instance.interceptors.request.use(requestInterceptor, errorHandler);

instance.interceptors.response.use(responseInterceptor, errorHandler);

twInstance.interceptors.request.use(requestInterceptor, errorHandler);

twInstance.interceptors.response.use(responseInterceptor, errorHandler);

export { twInstance };

export default instance;
